import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { createSequence } from '@olivierpascal/helpers';
import { generateAnalogousColorPalettes } from '../../helpers/colors/generateAnalogousPalettes';
import { ColorPickerContent } from '../ColorPickerContent';
import { generateAnalogousColorPalette } from '../../helpers/colors/generateAnalogousPalette';
export const HslColorPickerContent = forwardRef(function HslColorPickerContent(props, forwardedRef) {
    const { hueCount = 8, saturation = 80, lightnesses = [80, 65, 50, 35, 20], hideNeutral, ...other } = props;
    const palettes = generateAnalogousColorPalettes(saturation, hueCount, lightnesses);
    if (!hideNeutral) {
        palettes.push(generateAnalogousColorPalette(0, 0, createSequence(lightnesses.length, 0, 100 / (lightnesses.length - 1)).reverse()));
    }
    return (_jsx(ColorPickerContent, { styles: other.innerStyles?.colorPickerContent, palettes: palettes, ...other, ref: forwardedRef }));
});
